import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const StyledIntentSignalEventInfoWrapper = styled(FlexRow)`
    border-radius: 4px;
    background-color: ${colorsPalettes.carbon[25]};
    margin-right: 8px;
    justify-content: center;
    width: fit-content;
    height: fit-content;
    padding: 2px 8px;
    margin-bottom: 16px;
    cursor: default;
`;

export const StyledIntentTopicsListWrapper = styled(FlexRow)`
    flex-wrap: wrap;
`;
